import React, { useEffect, useState } from "react";
import "../styles/login.css";

export default function Login({ addToast }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");


  //TITLE BEÁLLITÁS
  useEffect(() => {
    document.title = "Bejelentkezés - FociFanatik"
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("https://focifanatik.hu/api/login.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: username,
          password: password,
        }),
        credentials: "include",
      });

      const data = await res.json();
      if (data.success) {
        addToast(data.success, "success");
        window.location.href = "/kezdolap";
      } else if (data.error) {
        addToast(data.error, "warning");
      }
    } catch (error) {
      addToast("Hiba történt a bejelentkezés során!", "warning");
    }
  };

  return (
    <>
      <section className="login-page">
        <form onSubmit={handleSubmit} className="login-form">
          <h3 className="text-center fw-bold mb-4">Bejelentkezés</h3>

          <div className="mb-3 username-inputbox">
            <label className="form-label labelForm">Felhasználónév</label>
            <input
              type="text"
              className="form-control form-control-lg"
              placeholder="Felhasználónév"
              name="usernameInputLog"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
            />
          </div>

          <div className="mb-4 password-inputbox">
            <label className="form-label labelForm">Jelszó</label>
            <input
              type="password"
              className="form-control form-control-lg"
              placeholder="Jelszó"
              name="passwordInputLog"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            className="btn-primary w-100 btn-lg register-btn"
          >
            Bejelentkezés
          </button>


          <p className="text-center mt-4 mb-0 text-muted small register-text">
            Nincs még fiókod?{" "}
            <a href="/regisztracio" className="register-link">
              Regisztráció
            </a>
          </p>
        </form>
      </section>
    </>
  );
}
